import repository from '@/repositories/repository'

export default baseUrl => {

    baseUrl = `${baseUrl}/funcionalidade-avaliacao-manual`

    return {
        store(params) {

            return repository.post(`${baseUrl}`, params)
        },
    }
}
